const STORAGE_KEY = 'cloudtalk-diagnostics-history';
const MAX_RESULTS = 5;

export interface TestHistoryEntry {
  timestamp: string;
  overallResult: 'PASS' | 'FAIL' | 'WARNING';
  mosScore: string | undefined;
  qualityScore: string;
  latencyAvg: string | undefined;
  packetLossAvg: string | undefined;
  bitrateAvg: string | undefined;
  natType: string | null;
  turnReachable: boolean;
}

/**
 * Save a test result to localStorage history. Keeps the last MAX_RESULTS entries.
 */
export function saveTestResult(entry: TestHistoryEntry): void {
  try {
    const history = getTestHistory();
    history.unshift(entry); // Add to the beginning (most recent first)
    if (history.length > MAX_RESULTS) {
      history.length = MAX_RESULTS; // Trim to max size
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch (e) {
    // localStorage may not be available (private browsing, quota exceeded, etc.)
    console.warn('Failed to save test result to localStorage:', e);
  }
}

/**
 * Get all stored test results from localStorage (most recent first).
 */
export function getTestHistory(): TestHistoryEntry[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return [];
    const parsed = JSON.parse(stored);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.warn('Failed to read test history from localStorage:', e);
    return [];
  }
}

/**
 * Clear all stored test results.
 */
export function clearTestHistory(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn('Failed to clear test history from localStorage:', e);
  }
}
